export const INIT_MAP = 'INIT_MAP';
export const REMOVE_INTERACTION_BY_TYPE = 'REMOVE_INTERACTION_BY_TYPE';
export const SET_BASEMAPS = 'SET_BASEMAPS';
export const TOGGLE_BASEMAP = 'TOGGLE_BASEMAP';

